/**
 * Lightweight browser fingerprint — combines hardware + browser signals
 * into a hash that survives cookie clearing.
 */
export async function getDeviceFingerprint() {
  const raw = [
    navigator.userAgent,
    navigator.language,
    screen.width + 'x' + screen.height,
    screen.colorDepth,
    navigator.hardwareConcurrency || '',
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.platform,
    navigator.maxTouchPoints || 0,
    !!window.indexedDB,
    !!window.sessionStorage,
  ].join('|');

  // Use SubtleCrypto for a stable hash if available
  try {
    const encoder = new TextEncoder();
    const data = encoder.encode(raw);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('');
  } catch {
    // Fallback: simple hash
    let h = 0;
    for (let i = 0; i < raw.length; i++) {
      h = ((h << 5) - h + raw.charCodeAt(i)) | 0;
    }
    return 'fp_' + Math.abs(h).toString(36);
  }
}
